import { AuthObjectState } from "utils/constants";
import { AuthActionObjectType, AuthReducerObjectType } from "utils/types";
import {
    AUTH_START,
    AUTH_SUCCESS,
    AUTH_FAIL,
    AUTH_RESET,
    RESET_TOKEN,
    AUTH_SUBSCRIPTION_STATUS,
} from "../actionTypes";

const initialState = AuthObjectState;

export const authReducer = (state = initialState, action: AuthActionObjectType): AuthReducerObjectType => {
    switch (action.type) {
        case AUTH_START:
            return {
                ...state,
                loading: true,
                error: false,
                data: {},
                has_subscribed: 0
            };
        case AUTH_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                has_subscribed: action.payload.has_subscribed
            };
        case AUTH_SUBSCRIPTION_STATUS:
            return {
                ...state,
                loading: false,
                has_subscribed: action.payload.has_subscribed
            };
        case AUTH_FAIL:
            return {
                ...state,
                loading: false,
                error: true
            };
        case AUTH_RESET:
            return AuthObjectState;

        case RESET_TOKEN:
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.payload
                }
            };
        default:
            return state;
    }
};